var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z",
    fill: "#FD6202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4038 8.80875C16.7422 7.09743 15.5936 5.61747 14.1001 4.5518C12.6065 3.48612 10.8335 2.88145 9.00001 2.8125C7.16655 2.88145 5.39347 3.48612 3.89993 4.5518C2.40639 5.61747 1.25785 7.09743 0.596255 8.80875C0.551574 8.93234 0.551574 9.06766 0.596255 9.19125C1.25785 10.9026 2.40639 12.3825 3.89993 13.4482C5.39347 14.5139 7.16655 15.1186 9.00001 15.1875C10.8335 15.1186 12.6065 14.5139 14.1001 13.4482C15.5936 12.3825 16.7422 10.9026 17.4038 9.19125C17.4484 9.06766 17.4484 8.93234 17.4038 8.80875ZM9.00001 12.6562C8.27687 12.6562 7.56997 12.4418 6.9687 12.0401C6.36743 11.6383 5.8988 11.0673 5.62207 10.3992C5.34534 9.73109 5.27293 8.99594 5.41401 8.2867C5.55509 7.57746 5.90331 6.92598 6.41465 6.41464C6.92598 5.90331 7.57746 5.55508 8.28671 5.414C8.99595 5.27293 9.7311 5.34533 10.3992 5.62207C11.0673 5.8988 11.6383 6.36743 12.0401 6.9687C12.4418 7.56996 12.6563 8.27686 12.6563 9C12.6548 9.96924 12.2691 10.8984 11.5837 11.5837C10.8984 12.2691 9.96925 12.6548 9.00001 12.6562Z",
    fill: "#FD6202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d16e5bd8676877f18afa8789bad0d438.svg";
export { ForwardRef as ReactComponent };